import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get } from "libs/services";
import { OrderItem } from "src/common/types/response/orders";
import { processPaginatedItems } from "src/common/libs/utils/items";
import { BaseResponse } from "src/common/types/response/BasePaginationResponse";
import { STORE_ORDER } from "src/common/libs/config/storeOrder.config";
import { QUERY_UTIL } from "src/common/libs/utils/dataUtils";

interface OrdersState {
  data?: BaseResponse<OrderItem>;
  loading: boolean;
  page: number;
}

export const getStoreOrders = createAsyncThunk(
  "order/getStoreOrders",
  async (
    {
      id,
      page = 1,
      limit = QUERY_UTIL.limit,
      status,
    }: { id: string; page?: number; limit?: number; status?: number[] },
    { rejectWithValue }
  ) => {
    try {
      const query = {
        limit,
        page,
        sort: "updated-desc",
      };
      if (status?.length > 0) {
        query["status"] = JSON.stringify(status);
      }
      const response = await Get<BaseResponse<OrderItem>>(
        `${STORE_ORDER.get}/${id}`,
        query
      );
      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(page);
    }
  }
);

// export const postOrder = createAsyncThunk(
//   "order/postOrder",
//   async (body: PostOrderRequest, thunkAPI) => {
//     try {
//       thunkAPI.dispatch(setLoading(true));
//       const response = await Post(ORDER.post, body);
//       return response.data;
//     } catch (error) {
//       thunkAPI.dispatch(
//         openToast({ message: error.response?.data?.message || error.message })
//       );
//       throw error;
//     } finally {
//       thunkAPI.dispatch(setLoading(false));
//     }
//   }
// );

const initialState: OrdersState = {
  data: null,
  loading: true,
  page: 1,
};

export const StoreOrderSlice = createSlice({
  name: "storeOrders",
  initialState,
  reducers: {
    clearData: () => initialState,
    updateStatus: (
      state,
      action: PayloadAction<{ orderId: string; status: number }>
    ) => {
      state.data = {
        ...state.data,
        payload: state.data.payload.map((it) => {
          if (it._id === action.payload.orderId) {
            return { ...it, status: action.payload.status };
          }
          return it;
        }),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStoreOrders.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getStoreOrders.fulfilled, (state, action) => {
      const { data, page } = action.payload || {};
      const filteredPayload = processPaginatedItems<any>(data, state.data);
      state.data = {
        ...state.data,
        ...filteredPayload,
      };
      state.page = page;
      state.loading = false;
    });
    builder.addCase(getStoreOrders.rejected, (state, action) => {
      if (action.payload === 1) {
        state.data = {
          ...state.data,
          payload: [],
        };
        state.loading = false;
      } else {
        state.loading = false;
      }
    });
  },
});

export const { clearData, updateStatus } = StoreOrderSlice.actions;

export default StoreOrderSlice.reducer;
